/**
 *
 * Asynchronously loads the component for MemberTags
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
